export default "__VITE_ASSET__Bx5wKgDl__"